import { CustomerTemplate, FieldError, FieldInfo, SignatureInfo } from '../../src/types';

type FieldErrorFn = (value: string) => FieldError | undefined;

const checkLineCount = (maxLines: number) => (value: string): FieldError | undefined => {
    const lines = (value ?? '').split('\n');
    if(lines.length > maxLines) {
        return {
            message: 'errors.lines',
            intlData: {
                allowedLines: maxLines,
                usedLines: lines.length
            }
        }
    }
    return;
}

const combineErrors = (validators: [FieldErrorFn]) => (value: string): FieldError[] => {
    return validators.map<FieldError>(v => v(value) as FieldError)
        .filter(r => r !== undefined);
}

const signatureInfo: SignatureInfo = {};

const templateData: FieldInfo[] = [
    {
        key: 'content',
        name: {
            en: 'Content',
            de: 'Inhalt'
        },
        languageData: {
            'de': 'Enter text here / Hier Text eingeben',
            'en': 'Enter text here / Hier Text eingeben'
        },
        maxLength: 700,
        hide: false,
        isValid: combineErrors([checkLineCount(7)])
    }
];

export const templates: CustomerTemplate[] = [
    {
        key: 'Workwear',
        name: {
            de: 'Motiv CWS Workwear',
            en: 'Theme CWS Workwear',
        },
        width: 600,
        height: 846,
        scale: 1,
        languages: ['en'],
        signatureInfo,
        templateData,
    },
    {
        key: 'Healthcare',
        name: {
            de: 'Motiv CWS Healthcare',
            en: 'Theme CWS Healthcare',
        },
        width: 600,
        height: 846,
        scale: 1,
        languages: ['en'],
        signatureInfo,
        templateData,
    }
]